import React from 'react';
import { Title } from '../components';
import SectionIntro from './SectionIntro';
import { blogs } from '../data';
import Blog from './Blog';

const Blogs = () => {
  return (
    <section className="section bg-emerald-50" id="blogs">
      <Title title="blogs" />
      <div className="section-center rounded-3xl">
        <SectionIntro
          title="vietnam in the news"
          intro="Our blogs provide all necessary information about Vietnam from culture to destinations, from local food and drink to Vietnam tradition, or festivals and events. Besides, We also give the latest travel news, travel experience, useful advices and tips when traveling to Vietnam. "
        />
        <div className="grid-container">
          {blogs.map((blog, index) => (
            <Blog key={index} blog={blog} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blogs;
